import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { StorageService } from '../../service/storage.service';
import { ToolsService } from '../../service/tools.service';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  tracks = [];
  formData = {};
  lat: any = 0;
  lng: any = 0;
  zoom: any = 11;
  geocoder: any;

  constructor(
    public api: ApiService,
    public storage: StorageService,
    public tools: ToolsService,
    private router: Router,
    public mapsApiLoader: MapsAPILoader,
    public ac: AppComponent
  ) {
    this.ac.setLoading( true );
    this.loadTracks();
    this.storage.updateTracks();
  }

  ngOnInit() {
    setTimeout( function() {
      $('.modal').modal();
    }, 200);
  }

  loadTracks() {
    const keys = this.storage.getKeys();

    this.tracks = [];

    keys.forEach( val => {
      if ( val[ 'lastEvent' ] ) {
        this.getData(val);
      }
    } );

    this.ac.setLoading( false );
  }

  getData( track ) {
    if ( track[ 'track' ] ) {
      this.tracks.push( this.storage.getTrack( track[ 'track' ] ) );
    }
  }

  clearForm() {
    this.formData = {};
  }

  saveTrack() {
    this.ac.setLoading( true );
    const track = this.formData[ 'track' ].toUpperCase();
    this.storage.setTrack( track, { description: this.formData[ 'description' ], archived: false, type: 0 } );

    this.api.getTrack( track )
      .subscribe( res => {
        res[ 'description' ] = this.formData[ 'description' ];
        res[ 'archived' ] = false;

        this.storage.setTrack( track, res );

        this.loadTracks();

        this.clearForm();

        this.ac.setLoading( false );
      } );
  }

  getIcon( type ) {
    return this.tools.getIcon( type );
  }

  viewTrack( track ) {
    this.router.navigateByUrl('/view/' + track[ 'track' ]);
  }

  isOffline() {
    return !navigator.onLine;
  }

}



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/app/home/home.component.ts